import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

// Shown when the user arrives via a Supabase password-recovery link. The
// recovery link establishes a temporary session (PASSWORD_RECOVERY event); we
// intercept it in App.js and render this screen instead of dropping the user
// straight into Audee. On success we hand control back to Audee via onComplete.
function SetNewPassword({ onComplete }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }
    // Password updated; the recovery session is now a normal authenticated
    // session. Hand back to Audee.
    onComplete();
  };

  return (
    <div className="login-screen">
      <div className="login-inner">
        <div className="login-logo">
          <span className="logo-audee">Audee<span className="logo-dot">.</span></span>
        </div>
        <p className="login-subtitle">Set a new password</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label>New Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Create a new password"
              required
              autoComplete="new-password"
              autoFocus
            />
          </div>
          <div className="login-field">
            <label>Confirm Password</label>
            <input
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              placeholder="Re-enter new password"
              required
              autoComplete="new-password"
            />
          </div>
          {error && <div className="login-error">⚠ {error}</div>}
          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? 'Updating password...' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default SetNewPassword;
